import { styled } from "@mui/material"

export const ConectorComplemento = styled('div')(({ theme }) => ({
    position: 'relative',
    display: 'block',
    width: '100%',

    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '27px',
        bottom: 0,
        width: '1px',
        backgroundColor: theme.palette.divider,
    },

    '&:first-of-type::before': {
        top: '-8px',
    },

    '&:last-child::before': {
        bottom: '50%',
    },

    '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '28px',
        width: '16px',
        height: '1px',
        backgroundColor: theme.palette.divider,
        transform: 'translateY(-50%)',
    },
}))

export default ConectorComplemento